module.exports = __webpack_public_path__ + "img/australia-tuberculosis-female.2552a7f0.png";